import { useCallback, useRef, useState } from 'react';
import { useCatalogContext } from '../state/Catalog';
import { useOnIntersectingChange } from '@shared/utils/hooks/useOnIntersectingChange';

export const useCurationDetailsController = () => {
  const { addCatalogItemToRegistry, addCatalogItemLoading, isMobile, toggleSidebarNavMobile } = useCatalogContext();

  const [isExploreCurationsIntersecting, setIsExploreCurationsIntersecting] = useState(false);

  const exploreOthersTriggerPointRef = useRef(null);

  const onIntersectingTriggerPointEl = useCallback(
    (isIntersecting: boolean) => {
      if (isIntersecting && exploreOthersTriggerPointRef.current) {
        setIsExploreCurationsIntersecting(true);
      } else {
        setIsExploreCurationsIntersecting(false);
      }
    },
    [setIsExploreCurationsIntersecting],
  );

  useOnIntersectingChange(exploreOthersTriggerPointRef, onIntersectingTriggerPointEl);

  return {
    addCatalogItemToRegistry,
    addCatalogItemLoading,
    isMobile,
    toggleSidebarNavMobile,
    isExploreCurationsIntersecting,
    exploreOthersTriggerPointRef,
  };
};
